import { KentContinuousRebalancingConfigMode } from '@cast/types-kent';

export const MIN_SAVINGS_THRESHOLD_PERCENT = 0;
export const MAX_SAVINGS_THRESHOLD_PERCENT = 100;

export const MIN_NODE_AGE_SECONDS = 0;
export const MIN_CYCLE_INTERVAL_SECONDS = 60;

export const DEFAULT_FULL_MODE_CYCLE_INTERVAL_SECONDS = 1800;
export const DEFAULT_DRAIN_ONLY_CYCLE_INTERVAL_SECONDS = 60;
export const DEFAULT_DELETE_EMPTY_CYCLE_INTERVAL_SECONDS = 60;

export const YAML_INDENTATION = 2;

export const FIELD_NAMES = {
  enabled: 'enabled',
  mode: 'mode',
  fullModeCycleIntervalSeconds: 'fullModeCycleIntervalSeconds',
  drainOnlyCycleIntervalSeconds: 'drainOnlyCycleIntervalSeconds',
  deleteEmptyCycleIntervalSeconds: 'deleteEmptyCycleIntervalSeconds',
  minNodeAgeSeconds: 'minNodeAgeSeconds',
  savingsThresholdEnabled: 'savingsThresholdEnabled',
  savingsThresholdPercent: 'savingsThresholdPercent',
  advancedConfiguration: 'advancedConfiguration',
  aggressiveModeEnabled: 'aggressiveModeEnabled',
  aggressiveModeConfig: 'aggressiveModeConfig',
  aggressiveModeConfigAggressiveEviction: 'aggressiveEviction',
  aggressiveModeConfigIgnoreBlockingPdb: 'ignoreBlockingPdb',
  aggressiveModeConfigIgnoreInstanceCriteria: 'ignoreInstanceCriteria',
  aggressiveModeConfigIgnoreLocalPersistentVolumes:
    'ignoreLocalPersistentVolumes',
  aggressiveModeConfigIgnoreProblemJobPods: 'ignoreProblemJobPods',
  aggressiveModeConfigIgnoreProblemPodsWithoutController:
    'ignoreProblemPodsWithoutController',
  aggressiveModeConfigIgnoreProblemRemovalDisabledPods:
    'ignoreProblemRemovalDisabledPods',
  aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets:
    'ignoreZeroNodePoolDisruptionBudgets',
  aggressiveModeConfigIgnoreProblemRemovalDisabledNodes:
    'ignoreProblemRemovalDisabledNodes',
  aggressiveModeConfigIgnoreConsolidatable: 'ignoreConsolidatable',
  aggressiveModeConfigDrainTimeoutMinutes: 'drainTimeoutMinutes',
} as const;

export const AVAILABLE_KENT_CONTINUOUS_REBALANCING_CONFIG_MODES = [
  'EMPTY_NODE_REMOVAL',
  'BIN_PACKING',
  'CONTINUOUS_REBALANCING_CYCLE',
] as const satisfies KentContinuousRebalancingConfigMode[];
